import { AngularRoutesEnum, DojoRoutesEnum, NavigationBase } from "@core/layout/enums/layout-routes.enum";
import { MenuProfileSection } from "@core/layout/components/top-bar/components/menu-profile/models/menu-profile-section.model";
import { MenuProfileIds } from "@core/layout/components/top-bar/components/menu-profile/enums/menu-profile-ids.enum";
import { LinkUtils } from "@core/layout/utils/link.utils";

export const MENU_PROFILE_ITEMS: MenuProfileSection[] = [
	{
		id: MenuProfileIds.PROFIL,
		label: "Mon profil",
		icon: "user",
		items: [
			{
				id: MenuProfileIds.PROFIL_AGATHE_YOU,
				label: "Agathe You",
				action: null,
			},
			{
				id: MenuProfileIds.PROFIL_OPALINE,
				label: "Opaline, annuaire en ligne",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.CONFIGURATION,
					DojoRoutesEnum.MY_INFI,
				]),
				blank: false,
			},
		],
	},
	{
		id: MenuProfileIds.ESPACE_CLIENT,
		label: "Espace client",
		icon: "package",
		action: null,
	},
	{
		id: MenuProfileIds.PREFERENCES,
		label: "Mes préférences",
		icon: "setting",
		items: [
			{
				id: MenuProfileIds.PREFERENCES_MON_LECTEUR,
				label: "Mon lecteur",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.CONFIGURATION,
					DojoRoutesEnum.LECTEURS,
				]),
				blank: false,
			},
			{ id: MenuProfileIds.PREFERENCES_MES_SOINS_FAVORIS, label: "Mes soins favoris", action: null },
			{
				id: MenuProfileIds.PREFERENCES_AUTRES,
				label: "Autres préférences",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.PREFERENCES,
					DojoRoutesEnum.INIT,
				]),
				blank: false,
			},
		],
	},
	{
		id: MenuProfileIds.FORMATION,
		label: "Formation",
		icon: "lightbulb-alt",
		items: [
			{ id: MenuProfileIds.FORMATION_FAQ, label: "FAQ", url: "https://intercom.help/cba/fr/", blank: true },
			{
				id: MenuProfileIds.FORMATION_TUTOS,
				label: "Tutos vidéos (Youtube)",
				url: "https://www.youtube.com/@mes-tutos-AY",
				blank: true,
			},
		],
	},
	{
		id: MenuProfileIds.LIENS_UTILS,
		label: "Liens utiles",
		icon: "link",
		items: [
			{
				id: MenuProfileIds.LIENS_UTILS_PRESCRIPTEURS,
				label: "Annuaire des prescripteurs",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ANNUAIRE,
					DojoRoutesEnum.PRATICIENS,
				]),
				blank: false,
			},
			{
				id: MenuProfileIds.LIENS_UTILS_CAISSES,
				label: "Annuaire des caisses",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ANNUAIRE,
					DojoRoutesEnum.CAISSES,
				]),
				blank: false,
			},
			{
				id: MenuProfileIds.LIENS_UTILS_NOMENCLATURE,
				label: "Nomenclature",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ORDONNANCES,
					DojoRoutesEnum.NOMENCLATURE,
				]),
				blank: false,
			},
			{
				id: MenuProfileIds.LIENS_UTILS_CONVENTIONNEMENT,
				label: "Conventionnement mutuelle",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ANNUAIRE,
					DojoRoutesEnum.CONVENTION_SIGNATURE,
				]),
				blank: false,
			},
			{
				id: MenuProfileIds.LIENS_UTILS_AMELI_PRO,
				label: "Ameli Pro",
				url: "https://authps-espacepro.ameli.fr",
				blank: true,
			},
		],
	},
	{
		id: MenuProfileIds.GESTION_ADMINISTRATION,
		label: "Gestion administrateur",
		icon: "user",
		items: [
			{
				id: MenuProfileIds.GESTION_ADMINISTRATION_ADMIN,
				label: "Interface Admin",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ADMIN_HOTLINE,
					DojoRoutesEnum.TDB,
				]),
				blank: false,
			},
			{
				id: MenuProfileIds.GESTION_ADMINISTRATION_MARKETING,
				label: "Interface marketing",
				url: LinkUtils.generateLinkModel(NavigationBase.DOJO, [
					DojoRoutesEnum.ADMIN_MARKET,
					DojoRoutesEnum.TDB,
				]),
				blank: false,
			},
			{
				id: MenuProfileIds.GESTION_ADMINISTRATION_DEV,
				label: "Interface dev",
				url: LinkUtils.generateLinkModel(NavigationBase.ANGULAR, [AngularRoutesEnum.ADMIN_DEV]),
				blank: false,
			},
		],
	},
];
